<template>
    <div v-if="!workspaces.length">
        <!-- This is an example component -->
        <div class="h-screen w-screen bg-gray-50 flex items-center">
            <div class="container flex flex-col md:flex-row items-center justify-between px-5 text-gray-700">
                <div class="w-full lg:w-1/2 mx-8">
                    <p class="text-2xl md:text-3xl font-light leading-normal mb-8">
                        <span class="text-4xl font-bold">
                            Không tìm thấy workspace
                        </span>
                    </p>

                    <hts-form-button
                        icon="arrow-right-on-rectangle"
                        color="success"
                        @click="handleSignOut">
                        Đăng xuất
                    </hts-form-button>
                </div>
                <div class="w-full lg:flex lg:justify-end lg:w-1/2 mx-5 my-12">
                    <img
                        src="https://user-images.githubusercontent.com/43953425/166269493-acd08ccb-4df3-4474-95c7-ad1034d3c070.svg"
                        class=""
                        alt="Page not found" >
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="w-[600px] mx-auto mt-[200px]">
            <h4>
                Your Workspaces:
            </h4>
            <div class="mt-4 w-full text-center">
                <template
                    v-for="(workspace, index) in workspaces"
                    :key="index">
                    <div class="border rounded-lg p-4 shadow mb-2">
                        <div
                            class="text-xl lg:text-2xl hover:text-blue-500 cursor-pointer"
                            @click="workspaceAccess(workspace)">
                            {{ workspace.name }}
                        </div>
                    </div>
                </template>
            </div>
            <hts-form-button
                icon="arrow-right-on-rectangle"
                color="error"
                icon-name="hi-arrow-left-end-on-rectangle-icon"
                @click="handleSignOut">
                Đăng xuất
            </hts-form-button>
        </div>
    </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'auth'
})

const { auth } = $store()
const router = useRouter()
const id = computed(() => router.currentRoute.value.params.id)
const isAdminRoute = computed(() => !id.value)

const store = $store()
const workspaces = computed(() => store.userConfig.workspaces)
const workspaceAccess = (workspace: any) => {
  const { _sid, companyType, timezone, type, cooperatorTypes } = workspace
  auth.setWorkspace({ id: _sid, companyType, timezone, type, cooperatorTypes })

  if (type === 'VENDOR') {
    if (['OWNER'].includes(companyType)) {
      return router.push({
        name: 'trucker-id-dashboard',
        params: { id: _sid }
      })
    }
    if (['PARTNER'].includes(companyType)) {
      if (cooperatorTypes.includes('PARTNER')) {
        return router.push({
          name: 'pp-id',
          params: { id: _sid }
        })
      }

      if (cooperatorTypes.includes('CUSTOMER')) {
        return router.push({
          name: 'pc-id',
          params: { id: _sid }
        })
      }
    }
  }

  if (type === 'IMPORT_AND_EXPORT') {
    if (['OWNER'].includes(companyType)) {
      return router.push({
        name: 'c-id-dashboard',
        params: { id: _sid }
      })
    }
  }

  $toast().error('Không tìm thấy Workspace.')
}

const handleSignOut = $lodash.debounce(async () => {
  const api: {} = !isAdminRoute.value
    ? {
      url: '/auth/user/logout',
      method: 'post'
    }
    : {
      url: 'admincp/auth/logout',
      method: 'post'
    }

  await $api(api)
  if (process.client) {
    store.system.clear()
    store.auth.clear()
    $toast().success($t('notifications.logoutSuccess'))
  }
  location.href = '/'
}, 500)
</script>
